import { CampaignType_Enum as CampaignType, Segment } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import type { UpsertAudience } from '@frontend/api-bulk-messaging';
import { AudienceTrayProvider } from '../providers/audience-tray-provider';
import { AudienceTrayBody } from './audience-tray-body';
import { AudienceTraySkeleton } from './audience-tray-skeleton';
import { useInitialRecipients } from './use-initial-recipients';

type Props = {
  campaignId: string;
  campaignType: CampaignType;
  closeTray: () => void;
  deleteSegments: (segments: Segment[]) => void;
  isUpsertingAudience: boolean;
  locationIds: string[];
  upsertAudience: UpsertAudience;
};

export const AudienceTrayLoader = ({
  campaignId,
  campaignType,
  closeTray,
  deleteSegments,
  isUpsertingAudience,
  locationIds,
  upsertAudience,
}: Props) => {
  const isMultiLocation = locationIds.length > 1;
  const enableManualSelection = !isMultiLocation && campaignType !== CampaignType.EMAIL;

  const { initialRecipients, isLoading: isTrayLoading } = useInitialRecipients({
    campaignId,
    enabled: enableManualSelection,
  });

  // TODO: If enableManualSelection is false, fetch the segments and contact lists

  return isTrayLoading ? (
    <AudienceTraySkeleton />
  ) : (
    <AudienceTrayProvider
      campaignId={campaignId}
      campaignType={campaignType}
      closeTray={closeTray}
      deleteSegments={deleteSegments}
      enableManualSelection={enableManualSelection}
      initialListIds={[]}
      initialRecipients={initialRecipients}
      isUpsertingAudience={isUpsertingAudience}
      locationIds={locationIds}
      upsertAudience={upsertAudience}
    >
      <AudienceTrayBody />
    </AudienceTrayProvider>
  );
};
